export class EmanetXIstemci {
    s;
    yenilemeBekleyen = null;
    constructor(s) {
        this.s = s;
    }
    async istek(yol, init = {}) {
        return this.istegiCalistir(yol, init, true);
    }
    async istegiCalistir(yol, init, yenilemeIzni) {
        const baslik = {
            ...init.headers,
        };
        // Body var ise JSON content-type ekle — bos body'de Fastify hata atiyor.
        if (init.body !== undefined && init.body !== null) {
            baslik['content-type'] = 'application/json';
        }
        if (init.yetkilendirme !== false) {
            const jeton = this.s.depo.erisim();
            if (jeton)
                baslik.authorization = `Bearer ${jeton}`;
        }
        const denetleyici = new AbortController();
        const zamanlayici = setTimeout(() => denetleyici.abort(), this.s.zamanAsimiMs ?? 30_000);
        try {
            const cevap = await fetch(`${this.s.tabanUrl}${yol}`, {
                ...init,
                headers: baslik,
                signal: denetleyici.signal,
            });
            if (cevap.status === 401 && yenilemeIzni && init.yetkilendirme !== false) {
                await this.yenile();
                return this.istegiCalistir(yol, init, false);
            }
            if (!cevap.ok) {
                const govde = (await cevap.json().catch(() => ({})));
                throw new EmanetXHata(cevap.status, govde.kod ?? 'bilinmeyen', govde.mesaj ?? cevap.statusText, govde);
            }
            if (cevap.status === 204)
                return undefined;
            return (await cevap.json());
        }
        finally {
            clearTimeout(zamanlayici);
        }
    }
    async yenile() {
        if (this.yenilemeBekleyen)
            return this.yenilemeBekleyen;
        const yenilemeJeton = this.s.depo.yenileme();
        if (!yenilemeJeton) {
            this.s.depo.sil();
            this.s.yenilemeBasarisiz?.();
            throw new EmanetXHata(401, 'yenileme_jeton_yok', 'Oturum sona erdi');
        }
        this.yenilemeBekleyen = (async () => {
            try {
                const cevap = await fetch(`${this.s.tabanUrl}/kimlik/yenile`, {
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify({ yenilemeJeton }),
                });
                if (!cevap.ok) {
                    const govde = (await cevap.json().catch(() => ({})));
                    console.warn('[sdk:yenile] basarisiz', {
                        durum: cevap.status,
                        kod: govde.kod,
                        mesaj: govde.mesaj,
                    });
                    // 401/403 → gercek kimlik hatasi, oturumu kapat.
                    // 5xx/network → gecici hata, jetonu KORU, sonra tekrar denenir.
                    if (cevap.status === 401 || cevap.status === 403) {
                        this.s.depo.sil();
                        this.s.yenilemeBasarisiz?.();
                    }
                    throw new EmanetXHata(cevap.status, govde.kod ?? 'yenileme_basarisiz', govde.mesaj ?? 'Oturum yenilenemedi');
                }
                const veri = (await cevap.json());
                this.s.depo.yaz({
                    erisimJeton: veri.erisimJeton,
                    yenilemeJeton: veri.yenilemeJeton,
                });
            }
            catch (hata) {
                // Network/timeout — jetonu KORU.
                if (!(hata instanceof EmanetXHata)) {
                    console.warn('[sdk:yenile] network hatasi, jeton korunuyor', hata);
                }
                throw hata;
            }
            finally {
                this.yenilemeBekleyen = null;
            }
        })();
        return this.yenilemeBekleyen;
    }
}
export class EmanetXHata extends Error {
    durum;
    kod;
    ayrintilar;
    constructor(durum, kod, mesaj, 
    /** Sunucudan donen tum hata gövdesi — sebep, sayilar, vb. extra alanlar burada. */
    ayrintilar) {
        super(mesaj);
        this.durum = durum;
        this.kod = kod;
        this.ayrintilar = ayrintilar;
        this.name = 'EmanetXHata';
    }
}
//# sourceMappingURL=istemci.js.map